import {
  Grid,
  Container,
  Divider,
  IconButton,
  Button,
  Snackbar,
  Tabs,
  Tab,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { config } from "../config/config";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GitHubIcon from "@mui/icons-material/GitHub";
import ClearIcon from "@mui/icons-material/Clear";
import LaunchIcon from "@mui/icons-material/Launch";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CreateTicketModal from "../components/Modals/CreateTicketModal";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  FormControl,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ReactTimeAgo from "react-time-ago";
import moment from "moment";
import TabPanel from "../components/Tabs/TabPanel";
import ProjectFilter from "../components/Filters/ProjectFilter";
import EnvironmentFilter from "../components/Filters/EnvironmentFilter";
import DateFilter from "../components/Filters/DateFilter";
import ExpandableSection from "../components/Layout/ExpandableSection";

function tabPanelProps(index, role) {
  return {
    id: `tabpanel-${role}-${index}`,
    "aria-controls": `tabpanel-${role}-${index}`,
  };
}

const Dashboard = () => {
  require("moment-timezone");

  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({ PageSize: 500 });
  const [deployments, setDeployments] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const [deploymentToRelease, setDeploymentsToRelease] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const [currentTab, setCurrentTab] = useState(0);

  const handleFilterChange = (e) => {
    let name = e.target.name;
    setAppliedFilters((prevState) => ({
      ...prevState,
      [name]: e.target.value,
    }));
  };

  const addToRelease = (p, e) => {
    try {
      if (deployments.length > 0) {
        let d = deployments
          .filter((item) => item.environment === e && item.project === p)
          .sort((a, b) =>
            a.project.toLowerCase().localeCompare(b.project.toLowerCase())
          )
          .sort((c, d) =>
            c.app_name.toLowerCase().localeCompare(d.app_name.toLowerCase())
          );

        setDeploymentsToRelease((prevState) => [...prevState, ...d]);
      }
    } catch {}

    setAnchorEl(null);
  };

  const createReleaseTicket = (e) => {
    console.log(deploymentToRelease);
    if (deploymentToRelease.length > 0) {
      setDeploymentsToRelease(
        deploymentToRelease.filter(
          (value, index, self) => self.indexOf(value) === index
        )
      );

      setModalOpen(true);
    } else {
      console.log("No releases added for ticket creation");
      setErrorMessage(
        "You must add an environment to a release before creating a release ticket."
      );
      setShowError(true);
    }
  };

  const openAllInNewTab = (proj, env) => {
    if (deployments.length > 0) {
      var toOpen = deployments
        .filter((p) => p.project === proj)
        .filter((e) => e.environment === env);
      toOpen.forEach((o) => {
        setTimeout(() => {
          window.open(
            `${config.DEVOPS_ORG_URL}/${proj}/_build/results?buildId=${o.ado_build_id}&view=results`,
            `${proj}${env}`
          );
        }, 500);
      });
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleErrorClose = () => {
    setShowError(false);
  };

  const handleClick = (proj, i, event) => {
    setAnchorEl({ [`${proj}-${i}`]: event.currentTarget });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTabChange = (e, v) => {
    setCurrentTab(v);
  };

  const clearFilters = () => {
    setAppliedFilters({});
  };

  const goToLink = (link) => {
    window.open(link);
  };

  useEffect(() => {
    var queryParams = "";
    if (appliedFilters !== undefined) {
      Object.entries(appliedFilters).map(([key, value]) => {
        queryParams += `&${key.toLowerCase()}=${value}`;
        return null;
      });
    }
    if (
      (appliedFilters["startDate"] === undefined &&
        appliedFilters["endDate"] !== undefined) ||
      (appliedFilters["startDate"] !== undefined &&
        appliedFilters["endDate"] === undefined)
    ) {
    } else {
      fetch(
        config.API_URL + `/Deployment?isActivelyDeployed=true${queryParams}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setDeployments(data);
          setIsLoading(false);
        });
    }
  }, [appliedFilters]);

  if (!isLoading) {
    deployments.sort((a, b) =>
      a.environment.toLowerCase().localeCompare(b.environment.toLowerCase())
    );
    let deploymentsToReleaseCount = deploymentToRelease.length;
    let projects = Array.from(
      new Set(
        deployments
          .map((item) => item.project)
          .sort((a, b) => {
            a.toLowerCase().localeCompare(b.toLowerCase());
          })
      )
    );
    return (
      <div>
        <Container maxWidth="xl">
          <CreateTicketModal
            releases={deploymentToRelease}
            open={modalOpen}
            handleClose={handleModalClose}
          />
          <Grid container style={{ marginTop: "75px" }}>
            <Grid item xs={12}>
              <Typography variant="h4" style={{ display: "inline-block" }}>
                Deployments
              </Typography>
              <Button
                variant="contained"
                disableElevation
                color="primary"
                style={{ float: "right" }}
                onClick={(e) => createReleaseTicket(e)}
              >
                Create Release Ticket ({deploymentsToReleaseCount})
              </Button>
              <Divider />
            </Grid>

            <Grid item xs={12} style={{ marginTop: "10px" }}>
              <ExpandableSection label="Filter">
                <div>
                  <ProjectFilter
                    onChange={(e) => handleFilterChange(e)}
                  ></ProjectFilter>
                  <EnvironmentFilter
                    onChange={(e) => handleFilterChange(e)}
                  ></EnvironmentFilter>
                  <DateFilter
                    name="startDate"
                    label="StartDate"
                    onChange={(e) => handleFilterChange(e)}
                  />
                  <DateFilter
                    name="endDate"
                    label="EndDate"
                    onChange={(e) => handleFilterChange(e)}
                  />
                  <FormControl size="medium" sx={{ margin: 1.3 }}>
                    <TextField
                      onChange={(e) => handleFilterChange(e)}
                      label="ResultCount"
                      id={`input-filter-pagesize`}
                      name="PageSize"
                      value={appliedFilters.PageSize}
                    ></TextField>
                  </FormControl>
                  <IconButton onClick={clearFilters}>
                    <ClearIcon />
                  </IconButton>
                </div>
              </ExpandableSection>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                {deployments.length > 0 && (
                  <Tabs
                    value={currentTab}
                    onChange={handleTabChange}
                    aria-label="project-tabs"
                  >
                    {projects.map((proj, i) => {
                      return (
                        <Tab
                          label={proj}
                          key={i}
                          {...tabPanelProps(i, "project")}
                        ></Tab>
                      );
                    })}
                  </Tabs>
                )}
                {projects.length === 0 && (
                  <Typography>
                    No Deployments for your organization have been found.
                  </Typography>
                )}
              </Grid>
              {/* GENERATE PANELS */}
              {projects.map((proj, i) => {
                let envs = deployments
                  .filter((f) => f.project === proj)
                  .map((item) => item.environment)
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                return (
                  <Grid item xs={12} key={i}>
                    <TabPanel
                      value={currentTab}
                      index={i}
                      key={i}
                      role="project"
                    >
                      <Grid container>
                        {envs.map((env, j) => {
                          let deploy = deployments
                            .filter(
                              (f) => f.project === proj && f.environment === env
                            )
                            .sort((a, b) =>
                              a.app_name
                                .toLowerCase()
                                .localeCompare(b.app_name.toLowerCase())
                            );

                          return (
                            <Grid item xs={12} key={j}>
                              <Accordion key={j}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`${proj}-${env}-${i}-${j}`}
                                  id={`${proj}-${env}-${i}-${j}`}
                                >
                                  <Typography
                                    variant="h6"
                                    style={{ padding: "0px 0px 0px 15px" }}
                                  >
                                    <IconButton
                                      id={`button-${proj}-${env.toLowerCase()}-${j}`}
                                      aria-controls={`menu-${proj}-${env.toLowerCase()}-${j}`}
                                      aria-expanded={Boolean(
                                        anchorEl && anchorEl[`${proj}-${j}`]
                                      )}
                                      aria-haspopup="true"
                                      onClick={(e) => handleClick(proj, j, e)}
                                      style={{
                                        display: "inline",
                                      }}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>

                                    <Menu
                                      key={j}
                                      id={`menu-${proj}-${env.toLowerCase()}-${j}`}
                                      anchorEl={
                                        anchorEl && anchorEl[`${proj}-${j}`]
                                      }
                                      open={Boolean(
                                        anchorEl && anchorEl[`${proj}-${j}`]
                                      )}
                                      onClose={handleClose}
                                      keepMounted
                                    >
                                      <MenuItem
                                        onClick={() => addToRelease(proj, env)}
                                      >
                                        Add Environment To Release Ticket
                                      </MenuItem>

                                      <MenuItem onClick={handleClose}>
                                        Promote Environment (Coming Soon)
                                      </MenuItem>

                                      <MenuItem
                                        onClick={() =>
                                          openAllInNewTab(proj, env)
                                        }
                                      >
                                        Open All in New Tabs
                                      </MenuItem>
                                    </Menu>
                                    {env}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Application</TableCell>
                                        <TableCell>Version</TableCell>
                                        <TableCell>When?</TableCell>
                                        <TableCell>Actions</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {deploy.map((d, k) => {
                                        let tz_date = moment.tz(
                                          d.date,
                                          "America/New_York"
                                        )._d;
                                        return (
                                          <TableRow key={k}>
                                            <TableCell>{d.app_name}</TableCell>
                                            <TableCell>
                                              {d.version_num}
                                            </TableCell>
                                            <TableCell>
                                              <ReactTimeAgo date={tz_date} />
                                            </TableCell>
                                            <TableCell>
                                              <Button
                                                color="primary"
                                                variant="outlined"
                                                size="small"
                                                onClick={() =>
                                                  goToLink(
                                                    `${config.DEVOPS_ORG_URL}/${d.project}/_build/results?buildId=${d.ado_build_id}&view=results`
                                                  )
                                                }
                                                style={{ margin: "5px" }}
                                              >
                                                Go To Build
                                              </Button>
                                              {d.git_hash !== undefined &&
                                                d.git_hash !== null && (
                                                  <Button
                                                    color="primary"
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={() =>
                                                      goToLink(
                                                        `https://github.com/liquidxinc/${d.app_name}/commit/${d.git_hash}`
                                                      )
                                                    }
                                                  >
                                                    <GitHubIcon />
                                                  </Button>
                                                )}
                                              {d.jira_ticket !== undefined &&
                                                d.jira_ticket !== "" &&
                                                d.jira_ticket !== null && (
                                                  <Button
                                                    color="primary"
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={() =>
                                                      goToLink(
                                                        `https://liquidxinc.atlassian.net/browse/${d.jira_ticket}`
                                                      )
                                                    }
                                                  >
                                                    {d.jira_ticket}&nbsp;&nbsp;
                                                    <LaunchIcon />
                                                  </Button>
                                                )}
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                </AccordionDetails>
                              </Accordion>
                              <br></br>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </TabPanel>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <Snackbar
            open={showError}
            autoHideDuration={10000}
            onClose={handleErrorClose}
          >
            <Alert severity="error" sx={{ width: "100%" }}>
              {errorMessage}
            </Alert>
          </Snackbar>
        </Container>
      </div>
    );
  } else {
    return (
      <Container maxWidth="xl">
        <Grid container style={{ marginTop: "75px", display: "block" }}>
          <Grid item xs={12}>
            <LinearProgress style={{ margin: "0 auto" }} />
          </Grid>
        </Grid>
      </Container>
    );
  }
};
export default Dashboard;
